import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { LLNotistackSnackbarProvider } from '@/components-library';
import { Settings } from 'luxon';

async function enableMocking() {
  // if (process.env.NODE_ENV !== 'development') {
  //   return
  // }
  const { worker } = await import('./mocks/browser');
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  // return worker.start();
}

// if this setting is enabled every user will see the same UTC+0 time
// if disabled, time will be different for every user and it will display local time always
// Settings.defaultZone = 'UTC';
Settings.defaultLocale = 'en-US';

enableMocking().then(() => {
  const root = createRoot(document.getElementById('root'));

  // Disable StrictMode in production to prevent double renders
  const AppWrapper = import.meta.env.MODE === 'production' ? (
    <LLNotistackSnackbarProvider>
      <App />
    </LLNotistackSnackbarProvider>
  ) : (
    <React.StrictMode>
      <LLNotistackSnackbarProvider>
        <App />
      </LLNotistackSnackbarProvider>
    </React.StrictMode>
  );

  root.render(AppWrapper);
});
